module.exports = __webpack_public_path__ + "static/media/ico-select.cd2066ef.svg";